export {};

const VISIBLE_CLASS = 'sticky-add-to-cart--visible';

const initStickyAddToCart = (): void => {
    const stickyBar      = document.querySelector<HTMLElement>('.sticky-add-to-cart');
    const productSection = document.querySelector<HTMLElement>('#selected-product');

    if (!stickyBar || !productSection) return;

    let intersectionObserver: IntersectionObserver | null = null;

    /**
     * Observes `.product-selected__actions` (the button row) rather than the full
     * `#selected-product` section to trigger at the right scroll position.
     * rootMargin accounts for the top nav (104px) and bottom tab-bar (64px).
     */
    const attachIntersectionObserver = (): void => {
        intersectionObserver?.disconnect();

        const button = productSection.querySelector<HTMLElement>('.product-selected__actions');

        if (!button) return;

        intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                stickyBar.classList.toggle(VISIBLE_CLASS, !entry.isIntersecting);
            });
        }, {
            rootMargin: '-104px 0px -64px 0px',
        });

        intersectionObserver.observe(button);
    };

    attachIntersectionObserver();

    // Re-attach after AJAX updates replace the innerHTML of #selected-product.
    new MutationObserver(attachIntersectionObserver).observe(productSection, { childList: true });
};

document.addEventListener('DOMContentLoaded', initStickyAddToCart);
